module.exports = __webpack_public_path__ + "static/media/roanoke-inside-barbour.a4746e61.jpeg";